<template>
  <div class="online-messages">
    <!-- 搜索栏 -->
    <el-form :inline="true" :model="query" class="msg-search" @submit.native.prevent>
      <el-form-item label="姓名">
        <el-input
          v-model="query.name"
          placeholder="按姓名查询"
          clearable
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
      </el-form-item>
      <el-form-item label="电话">
        <el-input
          v-model="query.phone"
          placeholder="按电话查询"
          clearable
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="list"
      border
      stripe
      size="small"
      style="width: 100%"
      empty-text="暂无留言数据"
    >
      <el-table-column prop="name" label="姓名" min-width="90" show-overflow-tooltip />
      <el-table-column prop="phone" label="电话" min-width="120" show-overflow-tooltip />
      <el-table-column prop="email" label="邮箱" min-width="160" show-overflow-tooltip />
      <el-table-column prop="ageGroup" label="年龄段" min-width="100" :formatter="formatAgeGroup" />
      <el-table-column prop="message" label="留言内容" min-width="220" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip />
      <el-table-column prop="updateTime" label="更新时间" min-width="160" show-overflow-tooltip />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      class="msg-pagination"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="pageNumber"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { getOnlineMsg } from '@/api/message'

// 年龄段 value -> label 映射
const AGE_GROUP_MAP = {
  1: '3-6岁',
  2: '7-10岁',
  3: '11-14岁',
  0: '15岁以上'
}

export default {
  name: 'OnlineMessages',
  data() {
    return {
      query: {
        name: '',
        phone: null,
      },
      list: [],
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getOnlineMsg({
          entity: { name: this.query.name, phone: this.query.phone },
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        })
        // 兼容常见分页返回结构
        const data = res || {}
        this.list = data.list || data.records || data.rows || data.content || (Array.isArray(data) ? data : [])
        this.total = data.total || data.totalCount || data.totalElements || this.list.length
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pageNumber = 1
      this.fetchData()
    },
    handleReset() {
      this.query.name = ''
      this.query.phone = null
      this.pageNumber = 1
      this.fetchData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.pageNumber = 1
      this.fetchData()
    },
    handleCurrentChange(page) {
      this.pageNumber = page
      this.fetchData()
    },
    formatAgeGroup(row, column, cellValue) {
      const label = AGE_GROUP_MAP[cellValue]
      return label !== undefined ? label : (cellValue == null || cellValue === '' ? '-' : cellValue)
    }
  }
}
</script>

<style scoped>
.online-messages {
  padding: 4px 2px;
}

.msg-search {
  margin-bottom: 12px;
}

.msg-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
